import {TaskData, TaskDataTableRow} from '../../types/tasks.types';
import { capitalizeFirst } from '../../utils/utils';

const COLUMN_TITLES:string[]=['','Name','Complete'];
const NO_RECORDS_MSG='There are no records for this task';

export const TaskTable=function(props:{taskData:TaskData}){
	if(props.taskData.metaData.taskTitle==='')return null;
	let noRecordsMsg=props.taskData.tableData.length===0?NO_RECORDS_MSG:'';
	let columnTitles=COLUMN_TITLES.slice();
	columnTitles.push(capitalizeFirst(props.taskData.metaData.scoreType));
	let titles=columnTitles.map((title:string)=>{
		return <th key={title===''?'rank':title}>{title}</th>
	});
	let rows=props.taskData.tableData.map((row, index)=>{
		return(<TaskTableRow row={row}  key={'table-row-'+index} index={index} />)
	});
	return (
		<>
			<table id='teachers-task-table'>
				<thead><tr>{titles}</tr></thead>
				<tbody>{rows}</tbody>
			</table>
			<p>{noRecordsMsg}</p>
		</>
	);
};

const TaskTableRow=function(props:{row:TaskDataTableRow, index:number}){
	let scoreDisp=props.row.score===-1?'-':props.row.score;
	return(
		<tr>
			<td>{props.row.rank}</td>
			<td>{props.row.name}</td>
			<td>{props.row.complete}</td>
			<td>{scoreDisp}</td>
		</tr>
	)
}

